(function () {
  var MIN_CHARS = 4;

  function normalize(value) {
    return (value || '').trim();
  }

  function foldAccents(value) {
    return (value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function isSearchableQuery(query) {
    return normalize(query).length >= MIN_CHARS;
  }

  function applyProductSearchParams(params, query) {
    params.set('type', 'product');
    params.set('options[unavailable_products]', 'show');
    params.set('options[prefix]', 'last');
    var cleanQuery = normalize(query);
    if (cleanQuery) {
      params.set('q', cleanQuery);
    }
  }

  function getProductMetaFromElement(el) {
    if (!el) return null;
    return {
      title: el.getAttribute('data-product-title') || '',
      vendor: el.getAttribute('data-product-vendor') || '',
      handle: el.getAttribute('data-product-handle') || '',
      searchText: el.getAttribute('data-ci-search-text') || '',
    };
  }

  function productMatchesQuery(meta, query) {
    if (!meta || !isSearchableQuery(query)) return false;

    var needle = foldAccents(normalize(query));
    var haystacks = [
      meta.title,
      meta.vendor,
      meta.handle,
      meta.searchText,
      [meta.title, meta.vendor, meta.handle].join(' '),
    ];

    return haystacks.some(function (value) {
      return foldAccents(value).indexOf(needle) !== -1;
    });
  }

  function elementMatchesQuery(el, query) {
    return productMatchesQuery(getProductMetaFromElement(el), query);
  }

  window.CiSearchUtils = {
    MIN_CHARS: MIN_CHARS,
    normalize: normalize,
    foldAccents: foldAccents,
    isSearchableQuery: isSearchableQuery,
    applyProductSearchParams: applyProductSearchParams,
    getProductMetaFromElement: getProductMetaFromElement,
    productMatchesQuery: productMatchesQuery,
    elementMatchesQuery: elementMatchesQuery,
  };
})();
